import styled from 'styled-components'
import { Button } from '@mui/material'
import { CircularProgress } from '@mui/material'

interface Props {
  status: RequestStatus
  text: JSX.Element | string
  id?: string
  onClick: () => void
}

const CircularProgressWhite = styled(CircularProgress)`
  color: #fff;
`

export default function ExportButton({ status, text, id, onClick }: Props): JSX.Element {
  const elementId = id || Math.random().toString(36).substring(7)
  return (
    <Button variant="outlined" disabled={status === 'loading'} id={elementId} onClick={onClick}>
      {status === 'loading' ? <CircularProgressWhite size={24} /> : text}
    </Button>
  )
}
